import ReceiveManaModal from './ReceiveManaModal'

export default ReceiveManaModal
